import {
  markPlayerAsPaid,
  undoPlayerPayment,
} from '@/api/registrations/registrationsApi';

/** The two things the organizer can do to one player's half of an individual registration. */
export type PlayerPaymentAction = 'mark' | 'undo';

interface PlayerPaymentActionConfig {
  call: (
    tournamentId: string,
    registrationId: string,
    playerEmail: string,
  ) => Promise<void>;
  /** Read by the confirmation dialog. */
  dialog: {
    title: string;
    description: (playerName: string) => string;
    warning: string;
    confirmLabel: string;
    pendingLabel: string;
  };
  /** Read by the panel once the call settles. */
  toast: {
    successTitle: string;
    successBody: (playerName: string) => string;
    errorTitle: string;
    errorBody: string;
  };
}

/**
 * Everything that differs between the two actions lives here: the API call, the dialog copy and the
 * toasts. One record so adding or renaming an action is a single edit in a single file.
 */
export const PLAYER_PAYMENT_ACTIONS: Record<
  PlayerPaymentAction,
  PlayerPaymentActionConfig
> = {
  mark: {
    call: markPlayerAsPaid,
    dialog: {
      title: 'Registrar pago del jugador',
      description: (playerName) =>
        `Vas a registrar el pago de ${playerName}, que te llegó por fuera de la app (transferencia o efectivo).`,
      warning:
        'El pago se contabiliza como efectivo: el costo por utilizar GetMatch se suma a tu cuenta corriente, igual que cuando cobrás en mano. Si con este pago la pareja completa su inscripción, queda confirmada. Con el fixture ya generado, solo vas a poder deshacerlo mientras la pareja tenga otro pago registrado.',
      confirmLabel: 'Registrar pago',
      pendingLabel: 'Registrando...',
    },
    toast: {
      successTitle: 'Pago registrado',
      successBody: (playerName) => `Se registró el pago de ${playerName}.`,
      errorTitle: 'No se pudo registrar el pago',
      errorBody: 'Hubo un error al intentar registrar el pago de este jugador.',
    },
  },
  undo: {
    call: undoPlayerPayment,
    dialog: {
      title: 'Deshacer pago del jugador',
      description: (playerName) =>
        `Vas a deshacer el pago que registraste a mano para ${playerName}.`,
      warning:
        'El costo por utilizar GetMatch deja de sumar a tu cuenta corriente y la inscripción vuelve a quedar pendiente de ese pago. No se devuelve plata: el dinero que hayas recibido lo resolvés por fuera de la app.',
      confirmLabel: 'Deshacer pago',
      pendingLabel: 'Deshaciendo...',
    },
    toast: {
      successTitle: 'Pago deshecho',
      successBody: (playerName) => `Se deshizo el pago de ${playerName}.`,
      errorTitle: 'No se pudo deshacer el pago',
      errorBody: 'Hubo un error al intentar deshacer el pago de este jugador.',
    },
  },
};
